









































import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Loja } from '@/models'
import SeletorDeLojas from './SeletorDeLojas.vue'

@Component({
	components: {
		SeletorDeLojas,
	},
})
export default class SeletorDeLojasCompacto extends Vue {
	@Prop({ type: Boolean, default: false }) disableSeletorDeLojas!: boolean;
	@Prop({ type: String, default: null }) grupoEconomicoId!: string | null;

	get possuiAcessoIrrestrito() {
		return UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	get idUsuarioLogado(): string | undefined {
		return UserLoginStore.usuario?.id || undefined
	}

	get quantidadeSelecionada(): number {
		const valor = this.$attrs.value ?? (this.$attrs as any).modelValue
		return Array.isArray(valor) ? valor.length : (valor ? 1 : 0)
	}

	nomeDaLoja(item: Loja | string): string {
		if (typeof item === 'object' && item !== null) {
			return item.nomeFantasia || item.razaoSocial || ''
		}
		return String(item)
	}
}
